/*
 *   File : bar.js
 *   Author : https://evoqins.com
 *   Description : Bar chart component
 *   Integrations : 'react-chartjs-2'
 *   Version : 1.0.0
*/

// custom packages
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = (props) => {

    const OPTIONS = {
        indexAxis: 'x',
        responsive: true,
        maintainAspectRatio: false, // allow custom height
        aspectRatio: 2,
        plugins: {
            title: {
                display: false,
            },
            legend: {
                display: false
            },
            tooltip: {
                backgroundColor: '#000',
                bodyColor: '#fff',
                paddingRight: 12,
                borderRadius: 8,
                paddingLeft: 12,
                paddingTop: 8,
                paddingBottom: 8,
                cornerRadius: 12,
                bodyFont: {
                    family: 'Myriad Pro',
                    weight: '400',
                    size: 12
                },
                cornerRadius: 2

            }
        },

        scales: {
            yAxes: [{
                stacked: true,
                categoryPercentage: props.selectedOption === "Monthly" || "Yearly" ? 0.4 : 0.1,
                barPercentage: props.selectedOption === "Monthly" || "Yearly" ? 0.8 : 0.2
            }],
            x: {
                grid: {
                    display: true,
                },
                border: {
                    display: false,
                    dash: [2, 2]
                },
                ticks: {
                    color: '#8D6AAD',
                    font: {
                        size: 10,
                        weight: 400,
                        family: 'Myriad Pro',
                    }
                }
            },
            y: {
                grid: {
                    display: true,


                },
                border: {
                    display: false,
                    dash: [2, 2],

                },
                ticks: {
                    color: '#8D6AAD',
                    font: {
                        size: 10,
                        weight: 400,
                        family: 'Myriad Pro'
                    }
                }

            },
        },
        barSpacing: props.selectedOption === "Monthly" || "Yearly" ? 0 : 10
    };

    // gradient 
    const _getGradient = (ctx, chartArea) => {
        if (chartArea) {
            let width, height, gradient;
            const chartWidth = chartArea.right - chartArea.left;
            const chartHeight = chartArea.bottom - chartArea.top;
            if (gradient === null || width !== chartWidth || height !== chartHeight) {
                width = chartWidth;
                height = chartHeight;
                gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                gradient.addColorStop(0, 'rgba(103, 79, 255, 0.2)');
                gradient.addColorStop(1, '#8873FC');
            }
            return gradient;
        }
    };


    const _getSecondGradient = (ctx, chartArea) => {
        if (chartArea) {
            let width, height, gradient;
            const chartWidth = chartArea.right - chartArea.left;
            const chartHeight = chartArea.bottom - chartArea.top;
            if (gradient === null || width !== chartWidth || height !== chartHeight) {
                width = chartWidth;
                height = chartHeight;
                gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                gradient.addColorStop(0, 'rgba(255, 143, 107, 0.2)');
                gradient.addColorStop(1, '#FF8F6B');
            }
            return gradient;
        }
    };


    //labels
    const labels = props.data.label;

    const DATA = {
        labels,
        datasets: [
            {
                label: '',
                data: props.data.data,
                backgroundColor: function (context) {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;
                    return _getGradient(ctx, chartArea);
                },
                barThickness: props.barThickness ? props.barThickness : (props.selectedOption === "Monthly" || props.selectedOption === "Yearly") ? 20 : 20,
                borderRadius: 4
            },
        ],
    };

    const MULTI_BAR_DATA = {
        labels,
        datasets: [
            {
                label: '',
                data: props.data.data_one,
                backgroundColor: function (context) {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;
                    return _getGradient(ctx, chartArea);
                },
                barThickness: 14,
                borderRadius: 3
            },
            {
                label: '',
                data: props.data.data_two,
                backgroundColor: function (context) {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;
                    return _getSecondGradient(ctx, chartArea);
                },
                barThickness: 14,
                borderRadius: 3
            },
        ],
    };

    return (
        <div className='chart-wrapper d-flex flex-column h-100 w-100'>
            <Bar options={OPTIONS} data={props.type === 2 ? MULTI_BAR_DATA : DATA}  />
        </div>
    )
}

export default BarChart;